import { render, staticRenderFns } from "./spmy.vue?vue&type=template&id=4ff5ace4&scoped=true&"
import script from "./spmy.vue?vue&type=script&lang=js&"
export * from "./spmy.vue?vue&type=script&lang=js&"
import style0 from "./spmy.vue?vue&type=style&index=0&lang=css&"
import style1 from "./spmy.vue?vue&type=style&index=1&id=4ff5ace4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff5ace4",
  null
  
)

export default component.exports